// extracted by mini-css-extract-plugin
module.exports = {"planBanner":"PlanBanner-planBanner-7SaOIq","free":"PlanBanner-free-3Y-v1J","planTitle":"PlanBanner-planTitle-1ucTQ_","planText":"PlanBanner-planText-3a-668"};